export default __webpack_public_path__ + "static/design-system-c0754216c8408bd1d40befbe0650784d.png";